<template>
  <div>
    <MarketingStoreBanner />
    <div v-for="(payment, index) in data" :key="index" class="section-wrapper">
      <!-- <p v-if="!hideFee">·&nbsp;&nbsp;{{ payment.description }}</p> -->
      <CommonSection>
        <template v-slot:content>
          <v-layout justify-space-between class="color--blue" style="margin-bottom: 30px">
            <v-flex class="d-flex align-center">
              <img class="icon" src="@/assets/images/icons/earlypay/deposit.svg" />
              {{ payment.title }}
            </v-flex>
            <!-- <v-flex class="text-right">{{ $filters.commaFormat(payment.depositAmount) }} 원</v-flex> -->
          </v-layout>

          <template v-if="!payment.isCollecting">
            <v-expansion-panels flat multiple :value="[0, 1, 2, 3]">
              <PaymentDetail
                v-for="(detail, index) in payment.amountDetails"
                :key="'PaymentDetail' + index"
                :title="detail.title"
                :amountDetail="detail.data"
                :hideFee="hideFee"
                :hideDetail="hideFee && detail.title === '기타'"
              />
            </v-expansion-panels>
          </template>
          <template v-else>
            <v-spacer />
            <h4 class="text-center my-14">데이터 수집중</h4>
          </template>
        </template>
      </CommonSection>
    </div>
    <LoanButtons :showFooter="false" @show-transition="handleShowTransition" />
  </div>
</template>

<script>
import { sumByPropertyName } from '@/util/mathUtil'
import { mapGetters, mapState, mapActions } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'
import { commaFormat } from '@/filter/number'

export default {
  props: ['data', 'hideFee'],
  components: {
    CommonSection: () => import('@/components/earlypay/template/CommonSection.vue'),
    PaymentDetail: () => import('@/components/earlypay/template/EarlypayPaymentDetail.vue'),
    LoanButtons: () => import('@/components/loan/LoanButtons.vue'),
    MarketingStoreBanner: () => import('@/components/marketing/MarketingStoreBanner.vue'),
  },
  data() {
    return {
      investingAmount: 0,
    }
  },
  watch: {
    investingPullRevenue: {
      immediate: true,
      async handler(v) {
        if (!v) {
          return
        }
        const { data } = await defaultApi.getInvestingAmount(v.uuid)
        this.investingAmount = data || 0
      },
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('env', ['mode']),
    ...mapGetters('auth', ['referralCode']),
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'investingPullRevenue',
      'executedPullRevenue',
    ]),
    investingPercent() {
      if (!this.investingPullRevenue || !this.investingAmount) return 0
      return ((this.investingAmount / this.investingPullRevenue.amount) * 100).toFixed(0)
    },
    isExecuting() {
      return this.investingPullRevenue?.status === 'executing'
    },
    isContractable() {
      if (
        !this.investingPullRevenue ||
        !['investing', 'invested'].includes(this.investingPullRevenue.status) ||
        this.investingAmount < 1
      ) {
        return false
      }

      const now = this.$moment()
      const start = this.$moment(this.investingPullRevenue.contractStartTime)
      const end = this.$moment(this.investingPullRevenue.contractEndTime)
      return now.isSameOrAfter(start) && now.isBefore(end)
    },
  },
  methods: {
    ...mapActions('evaluation', ['isKcsAgreements', 'isHometaxAccounts']),
    // 리스트 아이템 목록의 합계 표시용
    sumByPropertyName,
    commaFormat,

    handleShowTransition(to) {
      this.$router.push(to)
    },

    async moveToLoan() {
      // check KCS
      // 약관동의 여부 check해야하지만,
      // 홈택스가 없으면 약관동의 여부 의미없고, 지금은 약관-->홈택스 순이니까 홈택스로 체크함.
      if (!(await this.isHometaxAccounts())) {
        this.$router.push({
          path: '/auth/accounts/hometax',
          query: { next: '/loan/pull-revenue' },
        })
      } else if (!(await this.isKcsAgreements())) {
        this.$router.push({
          path: '/signup/agreements/kcs',
          query: { next: '/loan/pull-revenue' },
        })
      } else {
        this.$router.push('/loan/pull-revenue')
      }

      /*
      // check KCS
      if( !this.isKcsAgreements() ) {
        this.$router.push({
          path: '/signup/agreements/kcs',
          query: {next: '/loan/pull-revenue'},
        })
      }
      else if (!this.isHometaxAccounts()) {
        this.$router.push({
          path: '/auth/accounts/hometax',
          query: {next: '/loan/pull-revenue'},
        })
      } else {

        this.$router.push('/loan/pull-revenue') 
      }

*/
    },
  },
}
</script>

<style lang="scss" scoped>
.basic-button--apply {
  background-color: #4163d5 !important;
  color: #ffe15b !important;
  border-radius: 10px;
}
</style>
